import * as React from 'react';
import './InstitutionTypesPage.scss';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as InstitutionTypeActions from '../../../actions/institutionTypes';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { InstitutionLookupsLayout } from '../../index';
interface IInstitutionTypesPageProps {
  location: Location;
  history: History;

  // From state
  formFilter: IFormFilter;
  institutionType: Dtos.InstitutionType[];
  loadingInstitutionTypes: boolean;
  loadInstitutionTypesSuccess: boolean;
  loadInstitutionTypesFailure: boolean;
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
  formRoles?: Dtos.RoleType[];
}
interface IInstitutionTypesPageActions {
  clearInstitutionTypes: InstitutionTypeActions.IInstitutionTypeClearActionCreator;
  loadInstitutionTypes: InstitutionTypeActions.IInstitutionTypeLoadActionCreator;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
  filter: InstitutionTypeActions.IInstitutionTypeFilterActionCreator;
}
type InstitutionTypesPageProps = IInstitutionTypesPageProps & IInstitutionTypesPageActions;
class InstitutionTypesPage extends React.PureComponent<InstitutionTypesPageProps, any> {
  constructor(props: InstitutionTypesPageProps) {
    super(props);
    this.clearInstitutionTypes = this.clearInstitutionTypes.bind(this);
  }
  componentDidMount() {
    const {
      loadInstitutionTypes
    } = this.props;
    loadInstitutionTypes();
  }
  componentWillReceiveProps(nextProps: InstitutionTypesPageProps) {}
  componentDidUpdate(prevProps: InstitutionTypesPageProps, prevState) {
    const {
      navigateReplace
    } = this.props;
  }
  componentWillUpdate(nextProps: InstitutionTypesPageProps) {}
  componentWillUnmount() {
    this.clearInstitutionTypes();
  }
  clearInstitutionTypes() {
    this.props.clearInstitutionTypes();
  }
  showInstitutionTypes(): boolean {
    const {
      loadingInstitutionTypes,
      loadInstitutionTypesSuccess
    } = this.props;
    if (!loadingInstitutionTypes && loadInstitutionTypesSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingInstitutionTypes
    } = this.props;
    return <InstitutionLookupsLayout loading={loadingInstitutionTypes} permission={Dtos.Permission.InstitutionTypesView} data-sentry-element="InstitutionLookupsLayout" data-sentry-component="InstitutionTypesPage" data-sentry-source-file="InstitutionTypesPage.tsx">
            {this.renderContent()}
        </InstitutionLookupsLayout>;
  }
  renderContent() {
    const {
      permissions
    } = this.props;
    return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Institution Types</h2>
                </div>
                <div className="col-6" style={{
          textAlign: 'right'
        }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionTypesView) && <Link className={"btn btn-primary"} url={"/settings/institution/institutiontypes/create"}>Create</Link>}
                </div>
            </div>
            {!this.showInstitutionTypes() ? "Loading Institution Types" : null}
            {this.showInstitutionTypes() ? <div className="patient-tables mt-2">
                        {this.createTable()}
                    </div> : null}
        </div>;
  }
  createTable() {
    const {
      institutionType
    } = this.props;
    if (!institutionType || institutionType.length == 0) {
      return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no institution types to view.</span>
            </div>;
    }
    const showPagination = institutionType.length > DEFAULT_PAGE_SIZE;
    return <div className="table-wrapper mb-3">
            <ReactTable data={institutionType} pageSizeOptions={PAGE_SIZE_OPTIONS} defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : institutionType.length} pageSize={showPagination ? undefined : institutionType.length} showPagination={showPagination} className="-striped -highlight -clickable mb-3" noDataText="There are currently no institutionType to display" resizable={false} getTdProps={(state, rowInfo: RowInfo, column, instance) => {
        return {
          onClick: (e, handleOriginal) => {
            const url: string = "/settings/institution/institutiontypes/" + rowInfo.original.id;
            this.props.navigate(url);
            if (handleOriginal) {
              handleOriginal();
            }
          },
          style: {
            color: rowInfo && rowInfo.original && rowInfo.original.active ? '#212529' : '#9e9e9e'
          }
        };
      }} columns={[{
        id: "id",
        Header: ' ',
        accessor: "id",
        className: "d-flex align-items-center justify-content-center",
        maxWidth: 50,
        Cell: props => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
      }, {
        id: "value",
        Header: 'Name',
        accessor: 'value',
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }]} />
        </div>;
  }
}
const mapStateToProps = (state: ITmdState, ownProps: InstitutionTypesPageProps): IInstitutionTypesPageProps => {
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    history: ownProps.history,
    location: state.routing.location,
    formFilter: state.institutionTypes.formFilter,
    institutionType: state.institutionTypes.formFilteredData,
    loadingInstitutionTypes: state.institutionTypes.loadState && state.institutionTypes.loadState.status == RequestState.Pending,
    loadInstitutionTypesSuccess: state.institutionTypes.loadState && state.institutionTypes.loadState.status == RequestState.Success,
    loadInstitutionTypesFailure: state.institutionTypes.loadState && state.institutionTypes.loadState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    formRoles: state.user.formRoles
  };
};
const mapDispatchToProps = (dispatch): IInstitutionTypesPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadInstitutionTypes: bindActionCreators(InstitutionTypeActions.LoadInstitutionType, dispatch),
    clearInstitutionTypes: bindActionCreators(InstitutionTypeActions.Clear, dispatch),
    filter: bindActionCreators(InstitutionTypeActions.Filter, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(InstitutionTypesPage);